import { useTranslation } from 'react-i18next';
import { Button } from 'components/universal/button';
import cls from './changeWorkplaceModal.module.scss';
import Select, { components } from 'react-select';
import { Workplace } from 'views/employee-management/useEmployees';
import { ReactComponent as ArrowDown } from '../../../assets/images/icon/icon-down.svg';
import { useState } from 'react';
import { DropdownIndicator } from '../addMultipleUser';

interface ChangeWorkplaceModalInterface {
    onCancel: (boolean) => void;
    workplaces: Workplace[];
    selectedWorkplace: Workplace,
    setWorkplace: (workplace: Workplace) => void;
    editWorkplace: () => void;
}

export const ChangeWorkplaceModal = ({
    onCancel,
    workplaces,
    selectedWorkplace,
    setWorkplace,
    editWorkplace
}: ChangeWorkplaceModalInterface) => {
    const { t } = useTranslation();
    const [tempWorkplace, setTempWorkplace] = useState<Workplace | null>(selectedWorkplace);

    return (
        <>
            <h3 className={cls.modalHeader}>{t('employeeManagement.changeWorkplaceModalTitle')}</h3>
            <p className={cls.selectedLabel}>{t('employeeManagement.changeWorkplaceModalChangeWorkplaceLibel')}</p>
            <div className={cls.workplaceContainer}>
                <p className={cls.workplace}>{selectedWorkplace.workplace_name}</p>
                <a className={cls.editLink} onClick={editWorkplace}>
                    Edytuj
                </a>
            </div>
            <p className={cls.anotherWorplaces}>{t('employeeManagement.changeWorkplaceModalAnotherWorkplaceLibel')}</p>
            <div className={cls.selectCustomWrapper}>
                <Select<Workplace, false>
                    className="react-select-container"
                    options={workplaces}
                    value={tempWorkplace}
                    onChange={option => setTempWorkplace(option)}
                    getOptionLabel={o => o.workplace_name}
                    getOptionValue={o => o.id.toString()}
                    classNamePrefix="react-select"
                    placeholder="Change workplace"
                    components={{ DropdownIndicator }}
                />
            </div>
            <div className={cls.modalButtonWrapper}>
                <Button className={cls.modalButton} styleType="border" type="button" onClick={onCancel}>
                    {t('employeeManagement.cancel')}
                </Button>
                <Button
                    className={cls.modalButton}
                    type="button"
                    onClick={() => {
                        if (tempWorkplace) {
                        setWorkplace(tempWorkplace);
                        }
                        onCancel(false);
                    }}
                    >
                    {t('employeeManagement.changeWorkplaceModalButtonChangeLabel')}
                </Button>
            </div>
        </>
    );
};